import { getAppVersion } from './app'
import { getEventParams } from './event_params'
import { getLanguageConfig, setI18n } from './lang'
import { getLocationInfo } from './location'
import { getLoginInfo } from './login'
import { getOpenId } from './openid'
import { URLQueries } from './url_query'
import { is, xenv } from '@didi/webx-js'
import { getChannelId } from './channel_id'
import { request } from '../api'
import { GlobalConfig } from '../config'
import { TechPageErrorGetApolloFail } from '@/lib/webx/tech_error_track'
import { SupportXenvLists } from '../config/prod_config'
import { getDefaultApollo } from '../config/local_default_apollo'
export * from './login'

const getFrom = () =>
  URLQueries.getQuery('businessType') === 'miniapp'
    ? 'xwebapp'
    : URLQueries.getQuery('from')

const getClientType = () => {
  /**
   * 去掉的历史逻辑：
   * 判断是小程序原生的时候，返回 from === 'xwebapp' ? 5 : 2
   * 如果是街兔电单车，判断条件：__mpx_mode__ === 'web' && /hm.passenger/i.test(ua) ，返回 4
   */
  return __mpx_mode__ === 'web' && is('passenger') ? 0 : null
}

const getTerminal = () => {
  switch (true) {
    // 鸿蒙端使用is('android')也为true，因此需要前置判断，后端4-其他
    case __mpx_mode__ === 'web' && is('passenger') && is('harmonyos'):
      return 5
    case __mpx_mode__ === 'web' && is('passenger') && is('iphone'):
      return 1
    case __mpx_mode__ === 'web' && is('passenger') && is('android'):
      return 2
    // 现在没小程序，先注释掉
    // 小程序逻辑，需要确认这俩判断是小程序吗？
    // case is('weixin') || is('alipay'):
    //   return 3
    default:
      return 0
  }
}

export const GlobalEnv = {
  openid: getOpenId(),
  lang: 'zh-CN',
  appVersion: '',
  from: getFrom() || '',
  clientType: getClientType(),
  terminal: getTerminal(),
  atDidao: !!(
    URLQueries.getQuery('from_bottombar') || URLQueries.getQuery('at_didao')
  ),
  xenv: xenv(),
  channelId: getChannelId(),
  eventParams: getEventParams(),
  loginInfo: {
    token: '',
    phone: '',
    uid: '',
  },
  // 没有城市 ID 到底怎么办，暂时先不兜底，获取不到城市就是 -1，等后端报错
  locationInfo: {
    cityId: -1,
    lat: 0,
    lng: 0,
  },
  isTrackCityId: true,
  apolloData: {}, // apollo配置数据
  get isLogin() {
    return !!this.loginInfo.token
  },
  get hasRecOrderEventParams() {
    return this.eventParams && Object.keys(this.eventParams).length !== 0
  },
}

let envInited = false
let initEnvPromise = null

/**
 * 初始化环境
 * @param {Object} options - 选项
 * @param {boolean} [options.needLocation = true] - 是否需要定位
 */
const _initEnv = async options => {
  const lang = await getLanguageConfig()
  GlobalEnv.lang = lang
  setI18n(lang)
  const needLocation =
    options && options.needLocation !== undefined
      ? !!options.needLocation
      : true
  const tasks = [getAppVersion(), getLoginInfo(options)]
  if (needLocation) {
    tasks.push(getLocationInfo())
  }
  if (typeof options.beforeInitPlantFormFn === 'function') {
    options.beforeInitPlantFormFn()
  }
  window.PerfTrack?.customTrack?.('$_init_env_tasks_start')
  const [appVersion, loginInfo, locationInfo] = await Promise.all(tasks)
  window.PerfTrack?.customTrack?.('$_init_env_tasks_end')

  if (!options?.forbidGetApollo) {
    // 默认下异步获取apollo数据，apollo接口数据响应较快，默认下异步返回，如果业务需要initEnv 时需同步的返回apollo数据，可以传入getApolloSync: true
    if (options?.getApolloSync) {
      await getApollo()
    } else {
      getApollo()
    }
  }
  GlobalEnv.appVersion = appVersion || ''
  GlobalEnv.loginInfo = loginInfo
  if (GlobalEnv.loginInfo.token) {
    try {
      window.Omega?.setConfig?.({ forbidReport: false })
    } catch (error) {
      console.log(error)
    }
  }
  if (needLocation) {
    GlobalEnv.locationInfo = locationInfo
    if (xenv() === 'passenger' && Number(GlobalEnv.locationInfo.cityId) === 0) {
      GlobalEnv.locationInfo.cityId = -1
    }
  }
  envInited = true
}

/**
 * 初始化环境
 * @param {Object} options - 选项
 * @param {boolean} [options.needLocation = true] - 是否需要定位
 */
export const initEnv = async options => {
  if (envInited && !options?.removeCacheEnv) return
  if (options?.removeCacheEnv) {
    initEnvPromise = null
  }
  if (!initEnvPromise) {
    initEnvPromise = _initEnv(options)
  }
  return initEnvPromise
}

export { setI18n } from './lang'

/**
 * 获取apollo配置
 */
export const getApollo = () => {
  // const partition_id = 1105 || partitionId || getPartitionId()
  // request
  //   .get(GlobalConfig.APIs.getApollo, {
  //     partition_id,
  //   })
  //   .then(data => {
  //     console.log('-getXenvApollo-data1', data)
  //     return data
  //   })
  //   .catch(() => {
  //     TechPageErrorGetApolloFail()
  //   })
  return request
    .get(GlobalConfig.APIs.getXenvConf, {
      xenv: xenv(),
    })
    .then(data => {
      console.log('-getXenvApollo-data2', data)
      GlobalEnv.apolloData = data
      return data
    })
    .catch(err => {
      console.log('-getXenvApollo-data2-233', err)
      if (SupportXenvLists.indexOf(xenv()) !== -1) {
        TechPageErrorGetApolloFail()
      }
      GlobalEnv.apolloData = getDefaultApollo()
      return GlobalEnv.apolloData
    })
}
